module.exports = __webpack_public_path__ + "img/26ne.fd15b57d.svg";